<template>
    <main>
      <div class="bg-white">
        <div class="md:px-12 max-w-screen-2xl mx-auto py-4 mt-2 mb-6">
          <h1 class="text-start text-4xl font-extrabold mt-6 px-4 lg:px-1">Our Building Community</h1>
          <p class="text-start text-2xl mt-4 px-4 lg:px-1">
            Discover the perfect resources to be an investor.
          </p>
        </div>
  
        <!-- Grid section -->
        <div class="md:px-12 max-w-screen-2xl mx-auto pb-12">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6 px-4 lg:px-1">
            <!-- Top-left image -->
            <img src="../assets/images/About Us.png" alt="Community Image 1" class="rounded-lg w-full h-auto object-cover" />
            
            <!-- Right big image -->
            <img src="../assets/images/Built to sell.png" alt="Community Image 2" class="rounded-lg w-full h-auto object-cover row-span-2 md:row-span-2" />
          </div>
        </div>
      </div>
    </main>
  </template>
  
  <script>
  export default {};
  </script>
  
  <style scoped>
  /* Optional: if you want to ensure consistent height, you can style the images */
  </style>
  